<template>
    <div>
        <div class="label mb-1" v-if="label">
            {{ label }}
        </div>
        <v-chip
            v-for="item in items" :key="item.value"
            :class="['item-chip', {'active': isActive(item.value)}]"
            v-ripple @click="setActive(item.value)"
        >
            {{ item.name }}
        </v-chip>
    </div>
</template>

<script>
export default {
    name: "ChipSelector",
    props: {
        label: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            default: () => []
        },
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            model: '',
        }
    },
    methods: {
        setDefaults() {
            const vm = this
            if(vm.value) vm.model = vm.value
        },
        isActive(value) {
            const vm = this
            return vm.model === value
        },
        setActive(value) {
            const vm = this
            vm.model = value
        }
    },
    watch: {
        model(val) {
            this.$emit('change', val)
        },
        value() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>

.label {
    font-size: 15px;
    color: #333333;
    font-weight: 700;
}

.item-chip {
    border-radius: 8px;
    margin-right: 8px;
    margin-bottom: 8px;
    background: #F2F2F2 !important;
    cursor: pointer;
}

.active {
    background: #CCFF99 !important;
    border: 1px solid #F9F9F9;
}

</style>